import { render, staticRenderFns } from "./AppInstall.vue?vue&type=template&id=24cdf4f5&scoped=true&"
import script from "./AppInstall.vue?vue&type=script&lang=ts&"
export * from "./AppInstall.vue?vue&type=script&lang=ts&"
import style0 from "./AppInstall.vue?vue&type=style&index=0&id=24cdf4f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cdf4f5",
  null
  
)

export default component.exports